<template>
  <div>
    <van-cell-group><van-field label="案号" :value="data.anno" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="被执行人" :value="data.name" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="立案时间" :value="data.liandate" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="执行法院" :value="data.executegov" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="省份" :value="data.province" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="执行标的（元）" :value="data.biaodi" placeholder="无" readonly /></van-cell-group>
    <van-cell-group><van-field label="身份证号码/组织机构代码" :value="data.partycardnum" placeholder="无" readonly /></van-cell-group>
  </div>
</template>

<script>
import detailMixin from "../mixins/detail-mixin"
export default {
  name: "zhiXingCheckDetail",
  mixins: [detailMixin],
  data() {
    return {
   
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
@import "../style.scss";
.r-1 /deep/ .van-collapse-item__content {
  padding: 0px 16px;
}
.coll2 .van-cell__value {
  flex: 1;
  margin-left: 8px;
}
.coll2 .van-cell {
  padding: 10px 0;

  &::after{
    left: 0;
  }
}

.coll3 /deep/ .van-field__label {
  flex: 1;
}
</style>